import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { Field } from '../../UI';

/**
 * E-mails do cliente (AW2-1136 Etapa 3) — porta de `EmailProvisorio.jsx`
 * real, lista somente-leitura, 3 checkboxes por item (Padrão/Boleto/Nota
 * Fiscal) — TODOS independentes, sem "Adicionar E-mail"/excluir (produção
 * real não tem nenhum dos dois aqui). "Padrão" pode aparecer marcado em
 * mais de um item ao mesmo tempo (AC6) — não há lógica de exclusividade
 * mútua aqui, ao contrário de `EmailDevedor.jsx`.
 */
export default function EmailCliente({ emails }) {
  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>E-mails:</Typography>
      {emails.map((email, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.5fr) minmax(0, 1fr)' },
            gap: 'clamp(10px, 0.8vw, 22px)',
            alignItems: 'end',
            mb: 1.5,
          }}
        >
          <Field label="E-mail:" value={email.email ?? ''} disabled />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FormControlLabel
              control={<Checkbox size="small" checked={Boolean(email.permitirPadrao)} disabled />}
              label={<Typography variant="body2">Padrão</Typography>}
              sx={{ ml: 0 }}
            />
            <FormControlLabel
              control={<Checkbox size="small" checked={Boolean(email.permitirBoleto)} disabled />}
              label={<Typography variant="body2">Boleto</Typography>}
              sx={{ ml: 0 }}
            />
            <FormControlLabel
              control={<Checkbox size="small" checked={Boolean(email.permitirNotaFiscal)} disabled />}
              label={<Typography variant="body2">Nota Fiscal</Typography>}
              sx={{ ml: 0 }}
            />
          </Box>
        </Box>
      ))}
    </>
  );
}

EmailCliente.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string,
    permitirPadrao: PropTypes.bool,
    permitirBoleto: PropTypes.bool,
    permitirNotaFiscal: PropTypes.bool,
  })),
};

EmailCliente.defaultProps = {
  emails: [],
};
